import { useContext } from "react"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { Box, Grid, IconButton, Typography } from "@mui/material"
import { Close as CloseIcon } from "@mui/icons-material"

export const FormHeader = ({handleBackClick}) =>{
    const {reconciliation_state} = useContext(ToolContext)
    const {reconData} = reconciliation_state
    return(
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" component="h2" fontWeight={600}>
                    Reconciliation
                </Typography>
                <IconButton onClick={handleBackClick} sx={{ color: 'error.main', '&:hover': { backgroundColor: 'error.main', color: '#FFFFFF'}}}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box p={2} fontSize={13} mb={2}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={6} lg={3} display="flex" justifyContent="space-between">
                        <Box>Branch Sale Number:</Box>
                        <Box fontWeight={800}>{reconData.data.id}</Box>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3} display="flex" justifyContent="space-between">
                        <Box>Branch:</Box>
                        <Box fontWeight={800}>{reconData.data.branchName}</Box>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3} display="flex" justifyContent="space-between">
                        <Box>Date:</Box>
                        <Box fontWeight={800}>{reconData.data.date}</Box>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3} display="flex" justifyContent="space-between">
                        <Box>Status:</Box>
                        <Box px={2} py={0.5} borderRadius={2}bgcolor={reconData.data.status === 1 ? "warning.main" : reconData.data.status === 2 ? "warning.main" : reconData.data.status === 3 ? "info.main" : reconData.data.status === 4 ? "success.main" : "grey.300"} color="#FFFFFF" fontWeight={600} fontSize={12}>
                            {reconData.data.status === 1 ? "To Reconcile" : reconData.data.status === 2 ? "For Review" : reconData.data.status === 3 ? "For Approval" : "Approved"}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}